/**
 * @generated SignedSource<<bb17d0b098037bcfe4e7bafe8189decd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SkillResult = "ALMOST_THERE" | "DEMONSTRATED" | "KEEP_LEARNING" | "NOT_STARTED" | "PASSED" | "PLACED_OUT" | "REVIEW" | "%future added value";
export type StudentSkillProgressReportFilterInput = {
  classIds: ReadonlyArray<string>;
  skillSubstateIds?: ReadonlyArray<string> | null | undefined;
  skillTypeIds?: ReadonlyArray<string> | null | undefined;
  standardGradeIds?: ReadonlyArray<string> | null | undefined;
  targetGroupIds?: ReadonlyArray<string> | null | undefined;
};
export type StudentsSkillProgressReportQuery$variables = {
  filter: StudentSkillProgressReportFilterInput;
  skip?: boolean | null | undefined;
};
export type StudentsSkillProgressReportQuery$data = {
  readonly studentSkillProgressReport?: ReadonlyArray<{
    readonly currentRoadmapId: number;
    readonly currentRoadmapName: string;
    readonly lastLogin: any | null | undefined;
    readonly roadmapPercentage: number;
    readonly skillIdsBySkillResults: ReadonlyArray<{
      readonly key: SkillResult;
      readonly value: number;
    }>;
    readonly student: {
      readonly firstName: string | null | undefined;
      readonly id: string;
      readonly lastName: string | null | undefined;
      readonly publicUserId: string | null | undefined;
    } | null | undefined;
  }>;
};
export type StudentsSkillProgressReportQuery = {
  response: StudentsSkillProgressReportQuery$data;
  variables: StudentsSkillProgressReportQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
          }
        ],
        "concreteType": "StudentProgress",
        "kind": "LinkedField",
        "name": "studentSkillProgressReport",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Student",
            "kind": "LinkedField",
            "name": "student",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "publicUserId",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "KeyValuePairOfSkillResultAndInt32",
            "kind": "LinkedField",
            "name": "skillIdsBySkillResults",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "roadmapPercentage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastLogin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentRoadmapId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentRoadmapName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StudentsSkillProgressReportQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StudentsSkillProgressReportQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2eec2f336f8c40685773c9cae9f30459",
    "id": null,
    "metadata": {},
    "name": "StudentsSkillProgressReportQuery",
    "operationKind": "query",
    "text": "query StudentsSkillProgressReportQuery(\n  $filter: StudentSkillProgressReportFilterInput!\n  $skip: Boolean = false\n) {\n  studentSkillProgressReport(filter: $filter) @skip(if: $skip) {\n    student {\n      id\n      firstName\n      lastName\n      publicUserId\n    }\n    skillIdsBySkillResults {\n      key\n      value\n    }\n    roadmapPercentage\n    lastLogin\n    currentRoadmapId\n    currentRoadmapName\n  }\n}\n"
  }
};
})();

(node as any).hash = "a6545d681d33946df6a033aa5f20cbda";

export default node;
